import { AuthHeader } from "~/components/layout/auth-header";
import { ContactUsContent } from "./contact-us-content";

export const ContactUsPage = () => (
  <>
    <AuthHeader displayNavigation={false} />
    <ContactUsContent />
  </>
);
